import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=ea4bb12e&scoped=true"
import script from "./detail-dialog.vue?vue&type=script&lang=js"
export * from "./detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=ea4bb12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4bb12e",
  null
  
)

export default component.exports